import { LabeledSearchableSelectField } from '@ooh/ui/components/labeled-searchable-select-field';
import type { SearchableSelectFieldOption as SelectOption } from '@ooh/ui/components/searchable-select-field';

export interface SupplierMappingFieldsLabels {
  supplierLabel: string;
  supplierPlaceholder?: string;
  /** Label for the clear/empty option, letting the operator undo an
   * accidental supplier pick back to unmapped. */
  clearOptionLabel: string;
}

export interface SupplierMappingFieldsProps {
  supplierOptions: SelectOption[];
  supplier: string;
  onSupplierChange: (next: string) => void;
  labels: SupplierMappingFieldsLabels;
  error?: boolean;
  testIdPrefix?: string;
}

/**
 * The "Dostawca" (default supplier) selector — a real supplier VALUE picker
 * (`AvailabilityProfile.defaultSupplierName`), not a file-column picker.
 * Kept as a standalone field outside `ColumnMappingTable` so that table's
 * "every row here maps to a file column" promise stays literally true. The
 * (Numer dostawcy) file-column counterpart is now a `ColumnMappingTable` row
 * — see `preview-phase.tsx`'s `buildColumnMappingRows` (CU-86cbafj4j).
 */
export function SupplierMappingFields({
  supplierOptions,
  supplier,
  onSupplierChange,
  labels,
  error,
  testIdPrefix = 'supplier-mapping',
}: SupplierMappingFieldsProps) {
  return (
    <LabeledSearchableSelectField
      id={`${testIdPrefix}-supplier-select`}
      label={labels.supplierLabel}
      options={supplierOptions}
      value={supplier}
      onChange={onSupplierChange}
      placeholder={labels.clearOptionLabel}
      searchPlaceholder={labels.supplierPlaceholder}
      allowEmpty
      emptyLabel={labels.clearOptionLabel}
      error={error}
      testId={`${testIdPrefix}-supplier-select`}
    />
  );
}
